import { PD, HD } from "../theme";

export function AnimatedTitle() {
  const nodes = [
    { x:  60, y: 180, r: 5.5, color: "#4D8A8A", dur: 7.2,  delay: -0.4 },
    { x: 155, y:  70, r: 3.5, color: "#7B6BA0", dur: 9.3,  delay: -2.1 },
    { x: 260, y: 240, r: 3,   color: "#5E8A6A", dur: 8.1,  delay: -5.5 },
    { x: 340, y:  40, r: 4.2, color: "#5E6AAE", dur: 8.7,  delay: -1.2 },
    { x: 470, y: 160, r: 3,   color: "#8B7BC2", dur: 10.4, delay: -3.8 },
    { x: 620, y:  70, r: 11,  color: "#5E6AAE", dur: 6.9,  delay: -0.9 },
    { x: 720, y: 260, r: 13,  color: "#B06B7D", dur: 8.4,  delay: -2.7 },
    { x: 880, y: 140, r: 5,   color: "#5E8A6A", dur: 7.8,  delay: -4.6 },
    { x: 945, y:  45, r: 3,   color: "#9590A8", dur: 9.1,  delay: -6.3 },
  ];

  const threads = [
    { a: 0, b: 2, dur: 13, delay:  -2 },
    { a: 0, b: 3, dur: 17, delay:  -9 },
    { a: 1, b: 3, dur: 14, delay:  -5 },
    { a: 2, b: 4, dur: 15, delay: -11 },
    { a: 3, b: 5, dur: 16, delay:  -4 },
    { a: 4, b: 6, dur: 18, delay:  -7 },
    { a: 5, b: 7, dur: 13, delay: -10 },
    { a: 6, b: 8, dur: 17, delay:  -3 },
    { a: 5, b: 8, dur: 15, delay:  -6 },
    { a: 4, b: 7, dur: 19, delay: -14 },
    { a: 1, b: 4, dur: 16, delay: -12 },
  ];

  const beams = [
    { cx: 175, cy: 160, w:  8, h: 360, rot:  -6, op: 0.28 },
    { cx: 415, cy: 160, w: 14, h: 380, rot:   9, op: 0.32 },
    { cx: 690, cy: 160, w:  6, h: 340, rot:  -4, op: 0.22 },
    { cx: 820, cy: 160, w:  9, h: 360, rot:  11, op: 0.25 },
    { cx: 500, cy: 170, w:  4, h: 1100, rot: 90, op: 0.18 },
    { cx: 500, cy:  95, w:  3, h: 1100, rot: 92, op: 0.14 },
  ];

  return (
    <div style={{ position: "relative", width: "100%", maxWidth: 720, margin: "0 auto", aspectRatio: "1000 / 320" }}>
      <svg
        viewBox="0 0 1000 320"
        width="100%" height="100%"
        preserveAspectRatio="xMidYMid meet"
        style={{ position: "absolute", inset: 0, display: "block", overflow: "visible" }}
      >
        <defs>
          {nodes.map((n, i) => (
            <radialGradient key={i} id={`twNodeGlow_${i}`}>
              <stop offset="0%"   stopColor={n.color} stopOpacity="0.9" />
              <stop offset="35%"  stopColor={n.color} stopOpacity="0.35" />
              <stop offset="100%" stopColor={n.color} stopOpacity="0" />
            </radialGradient>
          ))}
        </defs>
        <g>
          {beams.map((b, i) => (
            <rect
              key={i}
              x={b.cx - b.w / 2} y={b.cy - b.h / 2}
              width={b.w} height={b.h}
              fill={PD.thread} opacity={b.op}
              transform={`rotate(${b.rot} ${b.cx} ${b.cy})`}
            />
          ))}
        </g>
        <g>
          {threads.map((t, i) => {
            const a = nodes[t.a];
            const b = nodes[t.b];
            const len = Math.hypot(b.x - a.x, b.y - a.y);
            return (
              <line
                key={i}
                x1={a.x} y1={a.y} x2={b.x} y2={b.y}
                stroke="#B5B1C4" strokeWidth="0.9" strokeLinecap="round"
                strokeDasharray={`${len} ${len * 3}`} strokeDashoffset={len}
                opacity="0.55"
              >
                <animate
                  attributeName="stroke-dashoffset"
                  from={len} to={-len * 3}
                  dur={`${t.dur}s`} begin={`${t.delay}s`} repeatCount="indefinite"
                />
              </line>
            );
          })}
        </g>
        <g>
          {nodes.map((n, i) => (
            <circle key={i} cx={n.x} cy={n.y} r={n.r * 3.5} fill={`url(#twNodeGlow_${i})`}>
              <animate
                attributeName="opacity" values="0.35;0.75;0.35"
                keyTimes="0;0.5;1" dur={`${n.dur}s`} begin={`${n.delay}s`}
                repeatCount="indefinite" calcMode="spline" keySplines="0.4 0 0.6 1;0.4 0 0.6 1"
              />
            </circle>
          ))}
        </g>
        <g>
          {nodes.map((n, i) => (
            <circle key={i} cx={n.x} cy={n.y} r={n.r} fill={n.color} opacity="0.88">
              <animate
                attributeName="r"
                values={`${n.r * 0.92};${n.r * 1.08};${n.r * 0.92}`}
                keyTimes="0;0.5;1" dur={`${n.dur}s`} begin={`${n.delay}s`}
                repeatCount="indefinite" calcMode="spline" keySplines="0.4 0 0.6 1;0.4 0 0.6 1"
              />
            </circle>
          ))}
        </g>
      </svg>
      <h1
        style={{
          ...HD,
          position: "relative", zIndex: 1, margin: 0, padding: 0,
          width: "100%", height: "100%",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "clamp(44px, 10vw, 84px)", fontWeight: 700,
          color: PD.text, lineHeight: 1, letterSpacing: "0.01em",
          textTransform: "uppercase", pointerEvents: "none", userSelect: "none",
        }}
      >
        The Web
      </h1>
    </div>
  );
}
